import React, { FC } from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import Label from "components/Label";
import { Post, Tag } from "utils/content/blog";
import { documentToPlainTextString } from "@contentful/rich-text-plain-text-renderer";

import styles from "./styles.module.scss";

const Posts: FC<{
  posts: Array<Post>;
  tags: Array<Tag>;
  context?: { title: string; href: string };
}> = ({ posts, tags, context }) => {
  const router = useRouter();

  const tagsById = tags.reduce(
    (acc, { name, sys: { id } }) => ({ ...acc, [id]: name }),
    {}
  ) as { [id: string]: string };

  const getTagById = (id: string) => tagsById[id] || id;

  return (
    <ul className={styles.postList}>
      {posts.map(
        ({
          sys: { id },
          metadata,
          fields: { title, slug, description: postDescription, body, thumbnail }
        }) => {
          const description =
            postDescription || documentToPlainTextString(body);
          return (
            <li key={id} className={styles.post}>
              <Link
                href={`/blog/${slug}`}
                onClick={(e) => {
                  e.preventDefault();
                  router.push(
                    {
                      pathname: `/blog/${slug}`,
                      query: {
                        context: context ? JSON.stringify(context) : undefined
                      }
                    },
                    `/blog/${slug}`
                  );
                }}
              >
                <img
                  src={
                    thumbnail && thumbnail.fields
                      ? thumbnail.fields.file.url
                      : "placeholder.jpg"
                  }
                  alt={title}
                />
                <div className={styles.postContent}>
                  <div className={styles.tagList}>
                    {metadata.tags.map((tag) => (
                      <Label
                        className={styles.tag}
                        key={tag.sys.id}
                        variant="s-capitalized"
                      >
                        {getTagById(tag.sys.id)}
                      </Label>
                    ))}
                    {/* <Link href={} */}
                  </div>
                  <Label variant="h5" className={styles.postTitle}>
                    {title}
                  </Label>
                  {description && (
                    <Label variant="s" className={styles.postBody}>
                      {description}
                    </Label>
                  )}
                </div>
              </Link>
            </li>
          );
        }
      )}
    </ul>
  );
};

export default Posts;
